import React, { useEffect, useState } from "react";
import "./subHeader.scss";
import { useDispatch, useSelector } from "react-redux";
import { SET_SERIES_TYPE, SelectSeriesType, SelectSeriesTypeDisableFlag } from "../../../redux/2d-slice/seriesSlice2d";
import moment from "moment";
import { SelectAnnoucements, SelectCurrentGameTime, SelectNextGameTime, SelectUserWallet } from "../../../redux/2d-slice/gameInfo2dSlice";
import { useNavigate } from "react-router-dom";
import { AuthState } from "../../../context/AuthProvider";
import { SocketState } from "../../../context/SocketProvider";
import { SET_MAIN_LOADER } from "../../../redux/loaderSlice";
import Marquee from "react-fast-marquee";
import { selectPickGameGameInfo, selectPickNextDealTime, selectPickTrNo } from "../../../redux/3d_game_Slice/gameinfo3d";
import { selectPickWalletAmount } from "../../../redux/3d_game_Slice/gameinfo3d";
import { selectPickLastSaleAmount } from "../../../redux/3d_game_Slice/gameinfo3d";
// import { selectGameInfo } from "../../../redux/slice/gameInfoSlice";
import { resetPanel, selectEnterQt, selectRenderCardArray, selectTimeSloat3d } from "../../../redux/3d_game_Slice/panelSlice";
import TimeLeft3d from "../common/TimeLeft3d";
import { setAdvanceTimeSlotCount, setSelectTimeSlot, selectAdvaceTimeSlotCount } from "../../../redux/seriesSlice";

function getDate() {
  const today = new Date();
  const month = today.getMonth() + 1; // ✅ Fix: add +1
  const year = today.getFullYear();
  const date = today.getDate();

  // Optional: ensure 2-digit format (e.g., 30-10-2025)
  const formattedDate = `${date.toString().padStart(2, '0')}-${month.toString().padStart(2, '0')}-${year}`;
  return formattedDate;
}

function SubHeader3d() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { socket } = SocketState();
  let annoucements = useSelector(SelectAnnoucements);
  let seriesType = useSelector(SelectSeriesType);
  let seriesTypeDisableFlag = useSelector(SelectSeriesTypeDisableFlag);
  let nextGameTime = useSelector(SelectNextGameTime);
  let currentDrawTime = useSelector(SelectCurrentGameTime);
  let userWallet = useSelector(SelectUserWallet);
  let timeSlot = useSelector(selectTimeSloat3d);
  let enterQt = useSelector(selectEnterQt)
  let renderCardArry = useSelector(selectRenderCardArray);
  const advanceTimeSlotCount = useSelector(selectAdvaceTimeSlotCount);


  // New state and selectors from NavigationContainer
  const [currentDate, setCurrentDate] = useState(getDate());
  const [currentTime, setCurrentTime] = useState(moment().format('HH:mm:ss'));
  const nextDealTime = useSelector(selectPickNextDealTime);
  const lastTrNo = useSelector(selectPickTrNo);
  const lastSaleAmount = useSelector(selectPickLastSaleAmount);
  const walletAmount3d = useSelector(selectPickWalletAmount);
  const gameInfo = useSelector(selectPickGameGameInfo);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(moment().format('h:mm:ss')); // 12-hour format with AM/PM
    }, 1000);

    return () => clearInterval(timer); // Clean up on unmount
  }, []);

  useEffect(() => {
    window.addEventListener("keydown", downHandler);

    return () => {
      window.removeEventListener("keydown", downHandler);
    }
  }, [timeSlot, enterQt, renderCardArry])

  let downHandler = (e) => {
    let { key } = e

    if (key === 'F5') {
      e.preventDefault()
      dispatch(resetPanel())
    }

    if (key === 'F6') {
      let element = document.getElementById("printBtn")
      element.click()
    }
    if (key === 'F1') {
      navigate('result')
    }
    if (key === 'F3') {
      navigate('reprint/list')
    }
    if (key === 'F2') {
      navigate('account')
    }
    if (key === 'F4') {
      navigate('cancelCoupon')
    }
    if (key === 'F9') {
      navigate('advance')
    }

  }


  return (
    <>
      <table width="100%" style={{ marginTop: "0px" }} border='0'>
        <tbody>
          <tr>
            <td width="20%" style={{ border: '1px solid #000' }}>
              <h4 style={{ background: "rgb(150, 178, 217)", marginBottom: "0px", color: "red", textAlign: "center", fontWeight: "bold", fontSize: 'clamp(10px, 1.8vw, 18px)', padding: "6px", }}>
                {gameInfo?.data?.user_name || 'Xyz(U902636)'}&nbsp; Points :
                {walletAmount3d || 0} </h4>
            </td>
            <td width="20%" style={{ border: '1px solid #000' }}>
              <h4 style={{
                background: "#F8F8A2", padding: "5px", textAlign: "center",
                fontSize: 'clamp(10px, 1.8vw, 20px)', color: "#000", marginBottom: "0px"
              }}>
                <b>Today: {moment().format('ddd')},
                  &nbsp;{currentDate}</b>
              </h4>
            </td>
            <td width="20%" style={{ border: '1px solid #000' }}>
              <h4 style={{
                background: "rgb(150, 178, 217)", padding: "5px", textAlign: "center",
                fontSize: 'clamp(10px, 1.8vw, 20px)', color: "#000", marginBottom: "0px"
              }}>
                <b>Current Time: <span id="transaction_time" style={{ fontSize: 'clamp(14px, 1.8vw, 20px)', fontWeight: "bold" }}>
                  {currentTime}
                </span></b>
              </h4>
            </td>
            <td width="20%" style={{ border: '1px solid #000' }}>
              <h4 style={{
                background: "#F8F8A2", padding: "5px", textAlign: "center",
                fontSize: 'clamp(10px, 1.8vw, 20px)', color: "#000", marginBottom: "0px"
              }}>
                <b>Current Timeslot:&nbsp;
                  {nextDealTime || currentDrawTime || ''} </b>
              </h4>
            </td>
            <td width="20%" style={{ border: '1px solid #000' }}>
              <h4 style={{
                background: "rgb(150, 178, 217)", padding: "5px", textAlign: "center",
                fontSize: 'clamp(10px, 1.8vw, 20px)', color: "#000", marginBottom: "0px"
              }}>
                <b>Remain Time: <span id="remaintime" style={{ fontSize: 'clamp(10px, 1.8vw, 20px)', color: "red", fontWeight: "bold" }}>
                  <TimeLeft3d />
                </span></b>
              </h4>
            </td>
          </tr>
        </tbody>
      </table>
      <table width="100%" style={{ marginTop: "-1px" }}>
        <tbody>
          <tr>
            <td width="12.5%" style={{ cursor: 'pointer' }} onClick={() => {
              dispatch(resetPanel())
              dispatch(setSelectTimeSlot([]))
              dispatch(setAdvanceTimeSlotCount(0))
            }}>
              <center>
                <h5 style={{ marginBottom: "0px", color: "#fff", fontWeight: 'bold', background: "rgb(211, 15, 32)", fontSize: 'clamp(10px, 1.8vw, 18px)', padding: "4px" }}>
                  Refresh(F5)</h5>
              </center>
            </td>
            <td width="12.5%" style={{ cursor: 'pointer' }} onClick={() => navigate('result')}>
              <center>
                <h5 style={{ marginBottom: "0px", color: "#fff", fontWeight: 'bold', background: "rgb(17, 99, 88)",  fontSize: 'clamp(10px, 1.8vw, 18px)', padding: "4px" }}>
                  Result(F1)</h5>
              </center>
            </td>
            <td width="12.5%" style={{ cursor: 'pointer' }} onClick={() => navigate('account')}>
              <center>
                <h5 style={{ marginBottom: "0px", color: "#fff", fontWeight: 'bold',  background: "rgb(6, 0, 58)", fontSize: 'clamp(10px, 1.8vw, 18px)', padding: "4px" }}>
                  Account(F2)</h5>
              </center>
            </td>
            <td width="12.5%" style={{ cursor: 'pointer' }} onClick={() => navigate('reprint/list')}>
              <center>
                <h5 style={{ marginBottom: "0px", color: "#fff", fontWeight: 'bold', background: "rgb(6, 0, 58)", fontSize: 'clamp(10px, 1.8vw, 18px)', padding: "4px" }}>
                  Reprint(F3)</h5>
              </center>
            </td>
            <td width="12.5%" style={{ cursor: 'pointer' }} onClick={() => navigate('cancelCoupon')}>
              <center>
                <h5 style={{ marginBottom: "0px", color: "#fff", fontWeight: 'bold', background: "rgb(6, 0, 58)", fontSize: 'clamp(10px, 1.8vw, 18px)', padding: "4px" }}>
                  Cancel(F4)</h5>
              </center>
            </td>
            <td
              width="12.5%"
              style={{ cursor: 'pointer' }}
              onClick={() => navigate('advance')}
            >
              <h5
                className="font2 btn-hover color-17"
                id="myBtn"
                style={{
                  marginBottom: "0px",
                  color: "#fff",
                  background: "rgb(161 15 0)",
                  fontSize: 'clamp(10px, 1.8vw, 18px)',
                  padding: "4px",
                  textAlign: "center",
                  width: "100%",
                  fontWeight: "600",
                  position: "relative" // ⭐ important
                }}
              >
                Adv.Draw(F9) {' '}

                {/* 🟢 Green Count Badge */}
                {advanceTimeSlotCount > 0 && (
                  <span
                    style={{
                      
                      backgroundColor: "#cc2e2eff",
                      color: "#fff",
                      borderRadius: "50%",
                      width: "18px",
                      height: "18px",
                      padding: "5px",
                      fontWeight: "bold",
                      alignItems: "center",
                      justifyContent: "center",
                      lineHeight: "1"
                    }}
                  >
                    {advanceTimeSlotCount}
                  </span>
                )}
              </h5>
            </td>

          </tr>
        </tbody>
      </table>
    </>
  );
}

export default SubHeader3d;